import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material';

@Injectable()
export class EguardmatSidenavHelperService
{
    sidenavInstances: MatSidenav[];

    constructor()
    {
        this.sidenavInstances = [];
    }

    setSidenav(id, instance)
    {
        this.sidenavInstances[id] = instance;
    }

    getSidenav(id)
    {
        return this.sidenavInstances[id];
    }
}



// WEBPACK FOOTER //
// ./src/app/core/directives/md-sidenav-helper/md-sidenav-helper.service.ts